import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiGet } from '../api';
import { IOrderHistory, ILogisticServiceHistory } from '../../types/suscription/history.types';

const { REACT_APP_SUBSCRIPTION } = process.env;

export const getOrderHistory = async (orderId: number): Promise<IOrderHistory[]> => {
  return apiGet<AxiosRequestConfig, IOrderHistory[]>(`${REACT_APP_SUBSCRIPTION}/order-history/${orderId}`)
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const getOrderHistoryByEventType = async (orderId: number, eventTypeId: number): Promise<IOrderHistory[]> => {
  return apiGet<AxiosRequestConfig, IOrderHistory[]>(
    `${REACT_APP_SUBSCRIPTION}/order-history/${orderId}/event-type/${eventTypeId}`
  )
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const getOrderHistoryByCategory = async (orderId: number, categoryId: number): Promise<IOrderHistory[]> => {
  return apiGet<AxiosRequestConfig, IOrderHistory[]>(
    `${REACT_APP_SUBSCRIPTION}/order-history/${orderId}/category/${categoryId}`
  )
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const getLogisticServiceHistory = async (serviceId: number): Promise<ILogisticServiceHistory[]> => {
  return apiGet<AxiosRequestConfig, ILogisticServiceHistory[]>(`${REACT_APP_SUBSCRIPTION}/service-history/${serviceId}`)
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const getLogisticServiceHistoryByEventType = async (
  serviceId: number,
  eventTypeId: number
): Promise<ILogisticServiceHistory[]> => {
  return apiGet<AxiosRequestConfig, ILogisticServiceHistory[]>(
    `${REACT_APP_SUBSCRIPTION}/service-history/${serviceId}/event-type/${eventTypeId}`
  )
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const getLogisticServiceHistoryByCategory = async (
  serviceId: number,
  categoryId: number
): Promise<ILogisticServiceHistory[]> => {
  return apiGet<AxiosRequestConfig, ILogisticServiceHistory[]>(
    `${REACT_APP_SUBSCRIPTION}/service-history/${serviceId}/category/${categoryId}`
  )
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};
